export class ReferenceAutoComplete{
    public id:string;
    public name?:string;
    public displayName?:string;
    public title?:string;
    public subTitle?:string;
    public detail?:string;
    public isMultiLine:boolean;
}